import { Request } from 'fetchboi'

export const getLectures = Request.register({
    endpoint: '/lectures',
    method: 'get',
    useAuthentication: true
})


export const getLecture = Request.register({
    endpoint: '/lectures/:id',
    method: 'get',
    useAuthentication: true
})

export const getLecturesByModule = Request.register({
    endpoint: '/lectures/?moduleId=:id',
    method: 'get',
    useAuthentication: true
})

export const getLecturesByCourse = Request.register({
    endpoint: '/lectures/?courseId=:id',
    method: 'get',
    useAuthentication: true
})

export const addLecture = Request.register({
    endpoint: '/lectures',
    method: 'post',
    useAuthentication: true
})

export const editLecture = Request.register({
    endpoint: '/lectures/:id',
    method: 'put',
    useAuthentication: true
})

export const deleteLecture = Request.register({
    endpoint: '/lectures/:id',
    method: 'delete',
    useAuthentication: true
})


// WEBPACK FOOTER //
// ./src/requests/lectures.js